import shallowProperty from './_shallowProperty.js';

// Internal helper to obtain the `byteLength` property of an object.
export default shallowProperty('byteLength');



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/_getByteLength.js
// module id = 177
// module chunks = 8